"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LayoutField;
var _react = _interopRequireWildcard(require("react"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function LayoutField(_ref) {
  var field = _ref.field,
    form = _ref.form;
  (0, _react.useEffect)(function () {
    if (field.value.layout === 'horizontal') {
      form.setFieldValue("".concat(field.name, ".enableGridX"), true);
      form.setFieldValue("".concat(field.name, ".enableGridY"), false);
    }
    if (field.value.layout === 'vertical') {
      form.setFieldValue("".concat(field.name, ".enableGridX"), false);
      form.setFieldValue("".concat(field.name, ".enableGridY"), true);
    }
  }, [field.value.layout]);
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Layout",
    name: "".concat(field.name, ".layout"),
    component: _cccisdFormik.CccisdSelect,
    options: ['vertical', 'horizontal'].map(function (o) {
      return {
        label: (0, _capitalize2["default"])(o),
        value: o
      };
    })
  });
}